import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule,ColumnChooserService, PageService, SortService, FilterService, ResizeService  } from '@syncfusion/ej2-angular-grids';
import { UsersHttpService } from './users.service';
import { UsersComponent } from './users.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { UsersRoutingModule } from './users-routing.module';
import { GetHTTPService } from './user-table.service';

@NgModule({
  declarations: [
    UsersComponent
  ],
  imports: [
    NgSelectModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgxUiLoaderModule,
    //NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
    MaskedTextBoxModule,
    UsersRoutingModule

  ],
  providers: [UsersHttpService,ColumnChooserService,PageService,SortService,FilterService,GetHTTPService, ResizeService ],
})
export class UsersModule { }
